/* tslint:disable */
/* eslint-disable */
/* @relayHash d5b12ae7eb5ea64fe23cc631fd12e94d */

import { ConcreteRequest } from "relay-runtime";
export type ClassroomInstanceSelectorQueryVariables = {
    courseID: number;
    afterDate?: string | null;
};
export type ClassroomInstanceSelectorQueryResponse = {
    readonly course: {
        readonly instances?: {
            readonly edges: ReadonlyArray<{
                readonly uuid: string;
                readonly startDate: string;
                readonly endDate: string;
            } | null> | null;
        } | null;
    } | null;
};
export type ClassroomInstanceSelectorQuery = {
    readonly response: ClassroomInstanceSelectorQueryResponse;
    readonly variables: ClassroomInstanceSelectorQueryVariables;
};



/*
query ClassroomInstanceSelectorQuery(
  $courseID: Int!
  $afterDate: Time
) {
  course(id: $courseID) {
    __typename
    ... on ClassroomCourse {
      instances(filter: {afterDate: $afterDate}) {
        edges {
          uuid
          startDate
          endDate
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "courseID",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "afterDate",
            "type": "Time",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "courseID"
        } as any)
    ], v2 = ({
        "kind": "InlineFragment",
        "type": "ClassroomCourse",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "instances",
                "storageKey": null,
                "args": [
                    {
                        "kind": "ObjectValue",
                        "name": "filter",
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "afterDate",
                                "variableName": "afterDate"
                            }
                        ]
                    }
                ],
                "concreteType": "ClassroomInstancePage",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClassroomInstance",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "uuid",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "startDate",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endDate",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ClassroomInstanceSelectorQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "course",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ClassroomInstanceSelectorQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "course",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ClassroomInstanceSelectorQuery",
            "id": null,
            "text": "query ClassroomInstanceSelectorQuery(\n  $courseID: Int!\n  $afterDate: Time\n) {\n  course(id: $courseID) {\n    __typename\n    ... on ClassroomCourse {\n      instances(filter: {afterDate: $afterDate}) {\n        edges {\n          uuid\n          startDate\n          endDate\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6b987e31bcfe942b75df51da0dab6985';
export default node;
